<template>
  <div class="custom-winwheel" v-if="!closed && blok.display === true">
    <div class="winwheel-content">
      <div class="close-wheel" @click="closeWheel()">x</div>
      <h2 v-html="blok.title"></h2>
      <p v-html="blok.text"></p>
      <div class="wheel">
        <div class="result" v-if="result">
          <img :src="won ? '/img/win.png' : '/img/lost.png'" alt="resultat roue" />
          <p v-if="!won">Dommage ! Une prochaine fois ! 😉</p>
          <p v-if="won">Bravo !!!!!!! Une place gagnée 😃</p>
        </div>
        <canvas id="canvas" width="434" height="434"
          >Canvas not supported, use another browser.</canvas
        >
      </div>
      <form @submit.prevent="spinWheel()">
        <input
          required
          type="email"
          id="email"
          name="email"
          v-model="form.email"
          placeholder="Adresse email"
        />
        <div class="checkbox">
          <input required type="checkbox" id="optin" v-model="form.optin" name="optin" />
          <vue-markdown class="markdown">{{ blok.optin }}</vue-markdown>
        </div>
        <button
          type="submit"
          :style="{ backgroundColor: blok.button_background.color, color: blok.button_color.color }"
        >
          {{ blok.button_text }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as Winwheel from "../../assets/winwheel.js";
export default {
  props: {
    blok: {
      type: Object
    }
  },
  data() {
    return {
      winwheel: null,
      won: false,
      form: {
        email: "",
        optin: true
      },
      closed: false,
      result: null
    };
  },

  mounted() {
    this.winwheel = new Winwheel.Winwheel({
      numSegments: this.blok.segments.length,
      outerRadius: 212,
      centerX: 217,
      centerY: 219,
      textFontSize: 28,
      segments: this.blok.segments.map(s => {
        return {
          fillStyle: s.background.color,
          textFillStyle: s.color.color,
          text: s.text,
          result: s.result,
          win: s.win,
          textFontSize: 20
        };
      }),
      animation: {
        type: "spinToStop",
        duration: 5,
        spins: 8,
        callbackFinished: this.finished
      }
    });
  },
  methods: {
    spinWheel() {
      if (this.result === null) {
        this.winwheel.startAnimation();
      }
    },
    closeWheel() {
      localStorage.setItem("winwheel", true);
      this.closed = true;
    },
    determineIfWon() {
      const generatedNumber = Math.floor(Math.random() * 50) + 1;
      if (generatedNumber === 45) {
        return true;
      }
      return false;
    },
    async finished(segment) {
      const won = this.determineIfWon();
      this.won = won;
      this.result = segment;
      localStorage.setItem("winwheel", true);
      try {
        await axios.post(
          `https://advg---roue-default-rtdb.europe-west1.firebasedatabase.app/users_cav.json`,
          {
            ...this.form,
            win: won,
            result: this.result,
            created_at: new Date().toISOString()
          }
        );
        if (won) {
          await axios.post(`https://mailing-advg-new.herokuapp.com/send_email`, {
            to: this.form.email,
            subject: this.blok.subject,
            from: this.blok.email,
            name: this.blok.name,
            html: `
              <mjml>
  <mj-body>
    <mj-section>
      <mj-column>
        <mj-image width="150px" src="https://a.storyblok.com/f/56057/842x595/0102230b8e/logo-city-aventure.jpg"></mj-image>
        <mj-divider border-color="#35b0cb"></mj-divider>
         <mj-text font-size="20px" line-height="1.2" color="#545454" font-family="helvetica">
           Félicitations !!! 🎉 Vous remportez une journée d'aventure en pleine nature ! 🌳<br/><br/>
           Vous recevrez dans les prochains jours un mail avec votre e-billet* ! 🎁<br/><br/>

Nous avons hâte de vous accueillir pour une journée riche en aventures !  😍<br/><br/>

            L'équipe City Aventure<br/>
          
        </mj-text>
         <mj-text font-size="14px" line-height="1" color="#545454" font-family="helvetica">
            * Le e-billet sera valable jusqu'au 7 novembre 2023. Consultez les jours et horaires d'ouverture sur https://www.cityaventure.com/fr 
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`
          });
        }
        setTimeout(() => {
          this.closed = true;
        }, 10000);
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss">
.custom-winwheel {
  position: fixed;
  z-index: 99999;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  .winwheel-content {
    width: 700px;
    max-width: 95%;
    background: #edefed;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 25px 15px;
    border-radius: 10px;
    position: relative;
    height: 90vh;
    overflow-y: auto;

    h2 {
      font-size: 35px;
      margin-bottom: 10px;
    }

    p {
      font-size: 20px;
      color: gray;
    }

    form {
      width: 350px;
      margin: auto;
      max-width: 95%;
      margin-top: 20px;

      input[type="email"] {
        background: #fff;
        border-radius: 4px;
        padding: 12px 15px;
        width: 100%;
        border: 1px solid #edefed;
        font-size: 20px;
      }

      button {
        padding: 10px 14px;
        border-radius: 4px;
        width: 100%;
        text-transform: uppercase;
        font-size: 21px;
        font-weight: bold;
        transition: background-color 0.4s;
        border: none;
        cursor: pointer;

        &:hover {
          background: #0f7d8b;
        }
      }

      .checkbox {
        display: flex;
        align-items: center;
        margin: 10px 0;

        input {
          flex: 1;
        }

        .markdown {
          flex: 10;

          color: gray;
          text-align: left;

          p {
            padding: 0;
            font-size: 15px;
          }
        }
      }
    }

    .close-wheel {
      position: absolute;
      top: 7px;
      right: 7px;
      cursor: pointer;
      font-size: 28px;
    }

    .wheel {
      background-image: url("/img/back.png");
      background-repeat: no-repeat;
      background-size: cover;
      margin: auto;
      display: flex;
      align-items: center;
      height: 580px;
      background-position: center;
      position: relative;
      justify-content: center;

      .result {
        position: absolute;
        z-index: 120;
        width: 90%;
        margin: auto;
        background: #edefed;
        border-radius: 20px;
        padding: 30px 10px;

        img {
          width: 60px;
          height: auto;
          margin: auto;
        }

        p {
          padding-top: 10px;
        }
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .custom-winwheel .winwheel-content .wheel {
    height: 340px;

    canvas {
      width: 250px;
      height: 250px;
    }
  }

  .custom-winwheel .winwheel-content {
    h2 {
      font-size: 25px;
    }

    p {
      font-size: 15px;
      padding: 5px 0;
    }

    form {
      button {
        font-size: 18px;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .custom-winwheel .winwheel-content .wheel {
    height: 300px;

    canvas {
      width: 200px;
      height: 200px;
    }
  }
}
</style>
